import { render, staticRenderFns } from "./install-plain.vue?vue&type=template&id=5298a72b&scoped=true"
import script from "./install-plain.vue?vue&type=script&lang=ts"
export * from "./install-plain.vue?vue&type=script&lang=ts"
import style0 from "./install-plain.vue?vue&type=style&index=0&id=5298a72b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5298a72b",
  null
  
)

export default component.exports